export default __webpack_public_path__ + "static/mybiz-42ac04b8c7f4e4e2c5bf2de9af3cb080.png";